import React from 'react'
import { Button, Modal } from 'react-bootstrap';
function ModalComponent({show,handleClose,imgPreview}) {


    
  return (
    <div>

  <Modal
    show={show}
    size="xl"
    onHide={handleClose}
    backdrop="static"
    keyboard={false}
  >
    
    <Modal.Header>
      <Modal.Title className="font_18">Image Preview</Modal.Title>
    </Modal.Header>
    <Modal.Body className="font_12 lh-lg termsBody overflow-auto">
      {imgPreview?.type == "img" &&
        <img src={imgPreview?.data} className="w-100 h-100 object_contain" alt='preview' loading='lazy'/>
  }
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="master"
        onClick={handleClose}
        className="text_uppercase font_12"
      >
        Close
      </Button>
    </Modal.Footer>
  </Modal>
    </div>
   
  )
}

export default ModalComponent
